import type { RouteConfig } from 'vue-router';

const routes: RouteConfig[] = [{
  path: '/s3-storage',
  name: 's3',
  redirect: { name: 's3Buckets' },
  component: () => import('@/self-service/pages/s3/SelfServiceS3Page.vue'),
  props: (route) => ({
    fullContent: route.name?.includes('s3BucketFileManager')
  }),
  meta: {
    title: $t => $t('S3'),
    restrictions: {
      action: 'read',
      resource: 's3_enable'
    },
  },
  children: [
    {
      path: 'buckets',
      name: 's3Buckets',
      component: () => import('@/self-service/pages/s3/buckets.vue'),
      meta: {
        title: $t => $t('Buckets'),
        breadcrumb: (_, $t) => Promise.resolve([{ name: $t('Buckets') }])
      },
      props: true,
      children: [
        {
          path: ':bucketName/:detailsTab(overview|bucket-policy)?',
          name: 's3BucketsDetails',
          meta: {
            title: $t => $t('S3 bucket details')
          }
        },
        {
          props: true,
          path: ':bucketName/bucket-policy/manage',
          name: 's3BucketsManage',
          meta: {
            title: $t => $t('Manage bucket policy'),
          },
          component: () => import('@/self-service/pages/s3/manageBucketPolicyDialog.vue'),
        },
      ]
    },
    {
      path: 'buckets/files/:bucketName',
      name: 's3BucketFileManager',
      component: () => import('@/self-service/pages/s3/bucketFileManager.vue'),
      props: (route) => ({
        bucketName: route.params.bucketName,
        path: route.query.path,
        fileId: route.params.fileId
      }),
      meta: {
        title: $t => $t('Bucket File Manager'),
        breadcrumb: (route, $t) => Promise.resolve([{
          name: $t('Buckets'),
          routeName: 's3Buckets'
        }, {
          name: route.params.bucketName,
          routeName: 's3BucketFileManager'
        }, {
          name: route.query.path as string,
          routeName: 's3BucketFileManager',
          routeParams: { bucketName: route.params.bucketName },
          routeQuery: { path: route.query.path as string },
          splitParts: true
        }])
      },
      children: [
        {
          path: 'add',
          name: 's3BucketFileManagerAddFolder',
          component: () => import('@/self-service/pages/s3/createFolder.vue'),
          props: (route) => ({
            bucketName: route.params.bucketName,
            path: route.query.path
          }),
          meta: {
            title: $t => $t('Add folder')
          }
        },
        {
          path: ':fileId',
          name: 's3BucketFileManagerDetails',
          meta: {
            title: $t => $t('File details'),
          }
        },
      ]
    },
    {
      path: 'access',
      name: 's3Access',
      component: () => import('@/self-service/pages/s3/access.vue'),
      children: [
        {
          path: 'create-key',
          name: 's3CreateKey',
          component: () => import('@/self-service/components/s3/DialogCreateKeyPage.vue'),
        }
      ]
    }
  ]
}];

export default routes;
